"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/** Assumes slides are uniform in width */
var _default = function _default(slider) {
  return slider.children[0].clientWidth;
};
exports["default"] = _default;
//# sourceMappingURL=_getSlideWidth.js.map